module.exports = __webpack_public_path__ + "static/media/EUCL.f68782c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/EUCL.jpg
// module id = 1741
// module chunks = 1